import type { SvgIconProps } from "@mui/material";
import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";

/**
 * Compact logo of Sprava Zeleznic: Logo with text beneath.
 * @component
 * @category ui
 * @subcategory feedback
 */
const SzCompactIcon: React.FC<{ logoColor?: string; companyNameColor?: string } & SvgIconProps> = ({
	logoColor,
	companyNameColor,
	...props
}) => {
	const theme = useTheme();
	return (
		<SvgIcon viewBox="-10 0 80.330132 101.50293" fontSize="inherit" {...props}>
			<defs>
				<clipPath id="clip_0">
					<path transform="matrix(1,0,0,-1,0,76.1272)" d="M0 0H60.248V76.127H0Z" />
				</clipPath>
			</defs>
			<g clipPath="url(#clip_0)">
				<path
					style={{
						fill: (theme.vars || theme).palette.primaryColors.blue.main,
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none",
					}}
					transform="matrix(1,0,0,-1,7.9464,74.2204)"
					d="M0 0H-4.191L-.426 4.264V5.42H-7.347V3.655H-3.724L-7.448-.609V-1.785H0ZM-1.502 7.703H-3.298L-3.897 6.983-4.495 7.703H-6.261L-4.871 5.969H-2.923ZM1.209-1.785H7.815V-.02H3.288V1.087H5.744V2.801H3.288V3.746H7.419V5.42H1.209ZM15.163 .02H11.103V5.42H9.024V-1.785H15.163ZM16.372-1.785H22.978V-.02H18.451V1.087H20.907V2.801H18.451V3.746H22.582V5.42H16.372ZM31.311 0H27.12L30.884 4.264V5.42H23.964V3.655H27.586L23.862-.609V-1.785H31.311ZM38.031-1.785H39.775V5.42H37.787V1.574L34.843 5.42H32.519V-1.785H34.558V2.639ZM41.542-1.785H43.621V5.42H41.542ZM48.727-1.907C51.264-1.907 52.076-.051 52.177 .619H50.077C49.965 .447 49.599-.051 48.727-.051 47.702-.051 47.093 .782 47.093 1.817 47.093 2.853 47.702 3.686 48.727 3.686 49.579 3.686 49.955 3.178 50.066 3.005H52.177C52.046 3.817 51.183 5.542 48.727 5.542 46.514 5.542 44.973 3.99 44.973 1.817 44.973-.345 46.514-1.907 48.727-1.907M-5.298 16.052C-5.298 15.747-5.014 15.575-4.506 15.534L-3.511 15.453C-1.654 15.311-.609 14.661-.609 13.087-.609 11.555-1.765 10.683-3.927 10.683-6.505 10.683-7.428 11.971-7.621 12.976H-5.43C-5.308 12.671-4.841 12.306-3.927 12.306-3.115 12.306-2.78 12.549-2.78 12.935-2.78 13.321-3.094 13.463-3.623 13.524-3.988 13.565-4.272 13.585-4.628 13.615-6.363 13.768-7.438 14.56-7.438 15.951-7.438 17.432-6.099 18.162-4.262 18.162-1.796 18.162-.984 17.016-.781 16.083H-2.861C-2.983 16.255-3.43 16.539-4.262 16.539-4.902 16.539-5.298 16.377-5.298 16.052M.712 18.02H5.137C6.801 18.02 7.815 17.188 7.815 15.575 7.815 13.971 6.801 13.129 5.137 13.129H2.781V10.815H.712ZM2.781 16.235V14.914H4.883C5.421 14.914 5.685 15.158 5.685 15.575 5.685 16.011 5.431 16.235 4.883 16.235ZM9.085 18.02H13.5C15.103 18.02 16.148 17.209 16.148 15.646 16.148 14.63 15.661 13.92 14.839 13.565L16.401 10.815H14.21L12.799 13.322H11.164V10.815H9.085ZM11.164 16.265V15.046H13.236C13.743 15.046 14.017 15.259 14.017 15.656 14.017 16.082 13.753 16.265 13.236 16.265ZM22.572 11.83H19.386L18.97 10.815H16.859L19.934 18.02H22.177L25.231 10.815H22.988ZM21.862 13.534 20.979 15.686 20.096 13.534ZM21.172 20.273H23.262L22.045 18.569H20.035ZM30.083 10.815H27.901L24.816 18.02H27.211L29.038 13.393 30.854 18.02H33.026ZM38.324 11.83H35.138L34.722 10.815H32.611L35.686 18.02H37.928L40.983 10.815H38.74ZM37.614 13.534 36.731 15.686 35.848 13.534Z"
				/>
				<path
					style={{
						fill: (theme.vars || theme).palette.primaryColors.orange.main,
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none",
					}}
					transform="matrix(1,0,0,-1,0,76.1272)"
					d="M60.248 67.715H0V76.128H60.248ZM0 36.801V28.389H60.248V36.801H30.054V37.956C31.798 39.139 33.507 40.345 35.256 41.522 43.381 46.987 50.4 51.708 60.248 51.708V60.119H0V51.708H33.51V50.537C32.547 49.863 31.571 49.181 30.561 48.502 21.631 42.496 13.193 36.824 .076 36.801Z"
				/>
			</g>
		</SvgIcon>
	);
};

export default SzCompactIcon;
